import { isIndividualContributorContent } from '../util';
/**
 * Migrated from https://github.com/themaven-net/tempest-phoenix/blob/1cb7d4f8321f84b1aa89a2ee8626cd2ffeb6311e/server/lib/util.js#L733
 * Produces an ad unit path based on provided site configuration and ContentItem
 * @returns A string containing the GAM ad unit path for ad delivery.
 */
export function makeAdUnitPathPrefix(siteConfig, item, options = {}) {
    // we initialize with an empty string so that the final result will start
    // with a '/' when we call Array.join
    const parts = [''];
    const adConfig = siteConfig?.ad;
    // The network portion of the path includes the primary account
    // network code (required), and any child network code that may
    // be configured for the site.
    const childNetwork = adConfig?.gamChildNetworkCode;
    parts.push(`${adConfig.gamNetworkCode}${(childNetwork && `,${childNetwork}`) ?? ''}`);
    // If a postNetworkCode parameter is provided, it will be included in the
    // ad unit path, following the network and/or child network code.
    if (typeof options.postNetworkCode === 'string') {
        parts.push(options.postNetworkCode);
    }
    const basePath = siteConfig.siteBasePath;
    let domainOrChannel = siteConfig.channelKey;
    // Additionally, for items that are authored by an individual contributor,
    // we supplement the domain portion of the path with a 'contributors'
    // keyword.
    if (isIndividualContributorContent(siteConfig, item) && siteConfig.siteProductionDomain) {
        domainOrChannel += '.contributors';
    }
    parts.push(domainOrChannel);
    // When a `siteBasePath` configuration value exists, this is included in the
    // ad unit path, following the domain.
    if (basePath && !(options.suppressBasePath ?? false)) {
        parts.push(basePath.replace(/^\//, '').replace(/\/$/, ''));
    }
    // If an item has been supplied and it has an assigned section, the section
    // key is added to the ad unit path.
    if (typeof item.section?.sectionKey === 'string') {
        parts.push(item.section.sectionKey);
    }
    return parts.join('/');
}
export default makeAdUnitPathPrefix;
//# sourceMappingURL=makeAdUnitPathPrefix.js.map